(ns splash.ui.lender-portal.common.request
  "Functions to assist making requests to backend services"
  (:require
    [ajax.core :as ajax]
    [splash.ui.lender-portal.config :as config]))

(def x-session-id (atom (random-uuid)))
(def x-request-id (atom 1))

(defn ->remote-uri
  [route]
  (str (config/remote-url) route))

(def base-request
  {:format (ajax/json-request-format)
   :response-format (ajax/json-response-format {:keywords? true})})

(def request-method->request-fn
  {:get ajax/GET
   :head ajax/HEAD
   :post ajax/POST
   :put ajax/PUT
   :delete ajax/DELETE
   :options ajax/OPTIONS
   :trace ajax/TRACE
   :patch ajax/PATCH
   :purge ajax/PURGE})

(defn mk-json-request
  [{:keys [uri headers method token] :as request}]
  (let [request-id @x-request-id
        remote-uri (->remote-uri uri)
        ctx-headers (merge headers
                      {"requesting-app" "lender-portal"
                       "x-session-id" @x-session-id
                       "x-request-id" request-id})
        options (-> (dissoc request :uri :method)
                  (merge base-request)
                  (update :headers #(merge %1 %2) ctx-headers)
                  (update :headers #(merge %1 %2) {"Authorization" (str "Bearer " token)}))
        request-fn (request-method->request-fn method)]
    (swap! x-request-id inc)
    (reset! x-session-id (random-uuid))
    (request-fn remote-uri options)))

(comment 
  
  (ajax/POST
    "https://lender-portal-api-stage.splashfinancial.com/api/v1/search"
    {:params {:application-id 12345}
     :headers {"Authorization" "Bearer "}})
  
  (mk-json-request {:uri "/api/v1/search"
                    :token "eyJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiIsImtpZCI6IjNQYUs0RWZ5Qk5RdTNDdGpZc2EzWW1oUTVFMCJ9.eyJhdWQiOiI0NGQ0YWZkMi1jZTYyLTQwZTQtODc2Ni1iMzY0MWM3NWE2NmUiLCJpc3MiOiJodHRwczovL2VkNTFkYmQ5LWI3MjAtNDhhOS1iM2IyLWY2OGQyNTliMTEwYy5jaWFtbG9naW4uY29tL2VkNTFkYmQ5LWI3MjAtNDhhOS1iM2IyLWY2OGQyNTliMTEwYy92Mi4wIiwiaWF0IjoxNzMwNDY5MTQ1LCJuYmYiOjE3MzA0NjkxNDUsImV4cCI6MTczMDQ3MzA0NSwiYWlvIjoiQVRRQXkvOFlBQUFBSzdZaENSbUNKa28xVldMemZBdGczdGpSS0FqUTBzdUV2VEE4TU96Z0ZJMWFmOVQ3UFpZQlY0WGJkYi81MnREVCIsImVtYWlsIjoibWZhdGljYSt0ZXN0MkBzcGxhc2hmaW5hbmNpYWwuY29tIiwiZ3JvdXBzIjpbImUwMWMyYWY5LWMwMGItNDk2Zi05ZmU5LWU4NzZjZjg5MTBhNCJdLCJuYW1lIjoiTWFyY28gRmF0aWNhIiwibm9uY2UiOiIwMTkyZTgwNC0yZmRkLTc5ZDktYmQwOS02MjgyMDczYTNiN2QiLCJvaWQiOiI2ZTM4MWNjNi01YmRlLTQ5YWYtOWI4OC0yZTJiOWY3YmZkNWIiLCJwcmVmZXJyZWRfdXNlcm5hbWUiOiJtZmF0aWNhK3Rlc3QyQHNwbGFzaGZpbmFuY2lhbC5jb20iLCJyaCI6IjEuQWM4QTJkdFI3U0MzcVVpenN2YU5KWnNSRE5LdjFFUml6dVJBaDJhelpCeDFwbTdQQUtqUEFBLiIsInJvbGVzIjpbIkJldGhwYWdlLlBMIiwiQmV0aHBhZ2UuU0xSIl0sInN1YiI6IkVwazJHdk8wcnlOZlhvTDBIQ3EtWmdHSGdyVGhZVmdmOF9ZTmNQWFFWRUkiLCJ0aWQiOiJlZDUxZGJkOS1iNzIwLTQ4YTktYjNiMi1mNjhkMjU5YjExMGMiLCJ1dGkiOiJ2QnVFTE0waldFaWI2SjI3V1N3Q0FBIiwidmVyIjoiMi4wIiwid2lkcyI6WyI4OGQ4ZTNlMy04ZjU1LTRhMWUtOTUzYS05Yjk4OThiODg3NmIiLCJiNzlmYmY0ZC0zZWY5LTQ2ODktODE0My03NmIxOTRlODU1MDkiXX0.Wdef7zcw2KY33XL8PW0QaNbhkxC4I1UcMLn69OXoUak873fWJG1asQku0cX8vD2cbVaRSHgtqoV4JKv2cCZQmSbVHaN9QcICQfahAINRRro9uEIZDtzR8iEaLe7p6idwRNvPEZ-lkyCsgzkbVZsuf3GOwkJP5epT0mDd75WGCzgCPQtdPwU3c5cOfg6LTxHSFKjYDCwQM3MpH47xPnZ_lJdXdvR-QeblDK-lvP-Tbqwsj_p_S9kH_UH8f1tEMIiX-jgS1W1qyGkezG2iI1lCYaMJaBExM7dHa0yn4QUKTHUceHXxK8ebHvcuHKvEz9VCmrlNdnUJakxhSd29Rew10g"
                    :method :post
                    :params {:application-id 12345}})

  )
